import { useQuery } from "@tanstack/react-query";

import BrieConversationAPI from "../../../api/api/BrieConversationAPI";
import { ReferenceValue } from "../../../types/TenantInterfaces";
import useUser from "../../../api/api-hooks/auth/useUser";

export interface BrieGPTUser {
  id: string;
  _id: string;
  Contact: ReferenceValue;
  PinnedChats: PinnedChats[];
}

export interface PinnedChats {
  id: string;
  Chat: ReferenceValue;
  Project?: ReferenceValue;
}

const useGPTUser = () => {
  const { user } = useUser();

  const gptUser = useQuery({
    queryKey: ["gptUser"],
    queryFn: async () => {
      return BrieConversationAPI.getBrieGPTUser().then(
        (res) => res.data.data.data
      );
    },
    enabled: !!user,
  });

  return {
    gptUser: gptUser.data as BrieGPTUser,
    isLoading: gptUser.isLoading,
    isError: gptUser.isError,
    error: gptUser.error,
  };
};

export default useGPTUser;
